import URL from '../url'
import Request from '../request'

export const listShopWebhooksService = () =>
  new Request(URL.API, URL.SHOP_WEBHOOKS).get()

export const createShopWebhookService = (data) =>
  new Request(URL.API, URL.SHOP_WEBHOOKS).post(data)

export const updateShopWebhookService = (id, data) =>
  new Request(URL.API, URL.SHOP_WEBHOOK_BY_ID.replace('{id}', id)).put(data)

export const deleteShopWebhookService = (id) =>
  new Request(URL.API, URL.SHOP_WEBHOOK_BY_ID.replace('{id}', id)).delete()
